import React from 'react';
import {useSelector} from "react-redux";
import {selectActivePost} from "../../../../store/reducers/postsReducer";
import CreateOrUpdatePost from "./CreateOrUpdatePost";

const UpdatePostContainer = () => {
    const post = useSelector(state => selectActivePost(state))
    return (
        <CreateOrUpdatePost post={post}/>
    );
};

export default UpdatePostContainer;